<template>
	<div>
		<div class="wh-block wh-block--reaction" v-if="current_link">
			<div class="reaction">
				<video preload="auto" controls autoplay controlsList="nodownload" @ended="stopReaction">
					<source type="video/mp4" :src="'/storage/app/media' + current_link" id="mp4">
				</video>
				<div class="reaction__stop"><button @click="stopReaction">Закрыть видео <span uk-icon="close"></span></button></div>
			</div>
		</div>

		<ul uk-accordion class="class_media">
			<li>
				<a class="uk-accordion-title" href="#">Обучающие материалы</a>
				<div class="uk-accordion-content">
					<div class="class_media__block">
						<ul class="uk-nav-default uk-nav-parent-icon" uk-nav>
							<li class="uk-parent" v-for="(l, k) in lessons" :key="l.id">
								<a href="#">{{ k }}</a>
								<ul class="uk-nav-sub">
									<li v-for="sl in l" class="class_media__item" :key="sl.id">
										<label>
											<input type="checkbox" class="uk-checkbox" :value="sl.id" v-model="class_lessons">
											<span>{{ sl.title }}</span>
										</label>
                    <button class="playvid" v-if="sl.file_name" @click="playVideo(sl.file_name)"></button>
                    <div v-if="sl.youtube" uk-lightbox="videoAutoplay:true"><a :href="sl.youtube" class="playvid" style="width: 30px"></a></div>
									</li>
								</ul>
							</li>
						</ul>
						<div class="class_media__button">
							<button class="uk-button uk-button-primary" @click="saveClassVideos('class_lessons')">Сохранить</button>
						</div>
					</div>
				</div>
			</li>
			<li>
				<a class="uk-accordion-title" href="#">Мультфильмы</a>
				<div class="uk-accordion-content">
					<div class="class_media__block">
						<ul class="class_media__items">
							<li v-for="m in mults" class="class_media__item" :key="m.id">
								<label>
									<input type="checkbox" class="uk-checkbox" :value="m.id" v-model="class_mults">
									<span>{{ m.title }}</span>
								</label>
                <button class="playvid" v-if="m.file_name" @click="playVideo(m.file_name)"></button>
                <div v-if="m.youtube" uk-lightbox="videoAutoplay:true"><a :href="m.youtube" class="playvid" style="width: 30px"></a></div>
							</li>
						</ul>
						<div class="class_media__button">
							<button class="uk-button uk-button-primary" @click="saveClassVideos('class_mults')">Сохранить</button>
						</div>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
  import swal from "sweetalert";

  export default {
    name: "class-media",
    data() {
      return {
        lessons: '',
        mults: '',
        class_lessons: [],
        class_mults: [],
        current_link: ''
      }
    },
    props: {
      item: ''
    },
    watch: {
      'item': 'checkClass'
    },
    inject: ['http'],
    methods: {
      async getClassVideos() {
        let result = await this.http.post('onGetAllVideos').then((res) => {
          this.mults = res.data.mults;
          this.lessons = res.data.lessons;
        });
      },
      checkClass() {
        if (this.item) {
          this.class_lessons = (this.item.params && this.item.params.class_lessons) ? this.item.params.class_lessons : [];
          this.class_mults = (this.item.params && this.item.params.class_mults) ? this.item.params.class_mults : [];
        }
      },
      stopReaction() {
        this.current_link = false;
      },
	    playVideo(link){
		    this.current_link = link;
	    },
      async saveClassVideos(type) {
        let data = {
          'arr': this[type],
          'name': type,
          'class_id': this.item.id
        }
        let result = await this.http.post('onSaveClassVideos', data).then((res) => {
          if (res.data.message) swal(res.data.message, "", "success");
        });
      }
    },
    mounted() {
      this.getClassVideos();
      this.checkClass();
    }
  }
</script>